import noSeriesImage from '../../../../asset/image/no-series.png'
import React from 'react'
import { Link } from 'react-router-dom'
import { EmptyState } from 'src/component/profile/empty-state/empty-state'
import { ProfileSection } from 'src/component/profile/profile-section/profile-section'
import { OutlinedButton } from 'src/component/ui/button'
import { Grid } from 'src/component/ui/grid/grid'
import { SeeAll } from 'src/component/ui/see-all'
import { SeriesCard, SeriesCardSkeleton } from 'src/component/ui/series-card'
import { HustlerProgramme, Programme } from 'src/dao/core-dao'
import { usePreviewSeries } from 'src/hook/use-preview-series'
import { useProfileSection } from 'src/hook/use-profile-section'
import { useMyCompletedProgrammes } from 'src/hook/use-programmes'
import { toasterUtil } from 'src/util/toaster-util'

export const CompletedSeries = (): React.ReactElement => {
  const {
    data: completedSeries,
    isLoading,
    isError,
  } = useMyCompletedProgrammes({
    onError: () => {
      toasterUtil.error('We are having difficulties loading your completed series, please try again.')
    },
  })

  const { items, isEmpty, hasMore, shouldShowSkeleton } = useProfileSection<HustlerProgramme, Programme>({
    data: completedSeries,
    isLoading,
    isError,
    extractItem: (hp) => hp.programme,
  })

  const { previewSeriesModal, startSeriesPreview } = usePreviewSeries()

  return (
    <ProfileSection theme="dark">
      {previewSeriesModal}
      <ProfileSection.Header>
        <ProfileSection.Title>COMPLETED SERIES</ProfileSection.Title>
        {!isLoading && !isError && hasMore && <SeeAll seeAllLink="/completed-series" theme="dark" />}
      </ProfileSection.Header>

      <ProfileSection.Content
        isLoading={shouldShowSkeleton}
        isEmpty={isEmpty}
        skeleton={
          <Grid.Skeleton>
            <SeriesCardSkeleton />
          </Grid.Skeleton>
        }
        empty={
          <EmptyState
            theme="dark"
            image={noSeriesImage}
            message="No completed series found, please explore our list of series!"
            action={
              <OutlinedButton asChild className="border-ivory text-ivory">
                <Link to="/programmes">SEE ALL SERIES</Link>
              </OutlinedButton>
            }
          />
        }
      >
        <Grid
          items={items}
          keyExtractor={(p) => p.id}
          renderItem={(programme: Programme) => (
            <SeriesCard.Default series={programme} onAction={() => startSeriesPreview(programme)} />
          )}
        />
      </ProfileSection.Content>
    </ProfileSection>
  )
}
